import React from 'react';
import { LocationPageTemplate } from '../../components/LocationPageTemplate';
export function MesaPage() {
  return <LocationPageTemplate city="Mesa" cityShort="Mesa" slug="mesa" data-id="element-1017" />;
}